<template>
  <div class="date-field-wrapper" :class="opened ? 'calendar-opened' : ''">
    <slot v-bind="bindings" />
    <calendar-input
      v-if="opened"
      v-model="date"
      :start-date="startDate"
      :end-date="endDate"
      :disabled-dates="disabledDates"
      :disabled-week-dates="disabledWeekDates"
      :lang="lang"
      :outer-activator="target"
      @close="opened = false"
    />
  </div>
</template>

<script>
  import $ from 'jquery'
  import CalendarInput from './calendar/calendar-input.vue'

  export default {
    name: 'date-field-input',
    components: {
      CalendarInput
    },
    props: {
      lang: {
        type: Object
      },
      emitEvent: {
        type: Boolean,
        default: false
      },
      minDate: {
        type: String,
        default: null
      },
      maxDate: {
        type: String,
        default: null
      },
    },
    data: () => ({
      date: null,
      opened: false,
      target: null,
      startDate: new Date().toISOString(),
      endDate: null,
      disabledDates: [],
      disabledWeekDates: []
    }),
    computed: {
      bindings() {
        return {
          value: this.date,
          onChange: this.changeDate,
          toggleCalendar: this.toggleCalendar
        }
      },
    },
    watch: {
      date(val) {
        const input = $(this.$el).find('input[type="date"]')
        if (input.val() !== val) {
          input.val(val)
          input.change()
          this.toggleCalendar(false)
          if (this.emitEvent) {
            this.$emit('dateChange', this.date)
          }
        }
      },
      opened(val) {
        if (!val) {
          this.target = null
        }
      },
      minDate(val) {
        this.$nextTick(() => {
          if (val) {
            this.startDate = val
            if (new Date(this.startDate) > new Date(this.date)) {
              this.date = val
            }
          }
        })
      }
    },
    mounted() {
      this.$nextTick(() => {
        const input = this.$el.querySelector('input')
        const startDate = this.minDate ? this.minDate : input.getAttribute('min')
        const endDate = this.maxDate ? this.maxDate : input.getAttribute('max')
        const preselectedDate = input.value
        const disabledWeekDates = input.getAttribute('data-val-disabled-week-days')
        if (startDate) {
          this.startDate = new Date(startDate).toISOString()
        }
        if (endDate) {
          this.endDate = new Date(endDate).toISOString()
        }
        if (disabledWeekDates) {
          this.disabledWeekDates = JSON.parse(disabledWeekDates)
        }
        if (preselectedDate) {
          this.date = preselectedDate
        }
      })
    },
    created() {
      this.$root.$on('reset-date-field', this.resetDateValue)
    },
    methods: {
      changeDate(e) {
        const inputValue = e.target.value

        if (this.emitEvent) {
          const [year] = inputValue.split('-')
          if (year.length === 4 && year[0] !== '0') {
            let newDate = inputValue

            if (this.minDate && new Date(this.minDate) > new Date(newDate)) {
              newDate = this.minDate
            }
            if (this.maxDate && new Date(this.maxDate) < new Date(newDate)) {
              newDate = this.maxDate
            }
            this.date = newDate
            this.$emit('dateChange', this.date)
          }
        } else {
          this.date = inputValue
        }
      },
      setDate(date) {
        this.date = date
      },
      resetDateValue() {
        this.date = null
      },
      toggleCalendar(val) {
        const haveVal = typeof val === 'boolean'
        if (typeof val === 'object' && 'target' in val) {
          this.target = val.target
        }
        this.opened = haveVal ? val : !this.opened
      }
    }
  }
</script>
